import axios from '../../axios/index';

export default {
    changeEnabled(id, value) {
        let formData = new FormData();
        formData.append('enabled', value);
        return axios.post('/api/v1/testing-subjects/changeEnabled/' + id, formData);
    },
    createTestingSubject(data) {
        let formData = new FormData();
        if (data.name !== null) {
          formData.append('name', data['name']);
        }
        return axios.post('/api/v1/testing-subjects', formData);
    },
    updateTestingSubject(id, data) {
        let formData = new FormData();
        if (data.name !== null) {
          formData.append('name', data['name']);
        }
        return axios.post('/api/v1/testing-subjects/' + id, formData);
    },
    getTestingSubjects() {
        return axios.get('/api/v1/testing-subjects');
    },
    loadLogs() {
        return axios.get('/api/v1/testing-subjects/logs');
    },
}
